import styled from "styled-components";

export const Container = styled.div`
  max-width: 1920px;
  margin: auto;
  padding: 0 16px; 
`;
